import html from '../legacy/rs.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function Rust() {
  return <LegacyHtmlPage slug="rs" title="Rust" html={html} />;
}
